import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0adf3982"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "poster-item--blend blend-1" }, null, -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "poster-background" }

import { computed, onMounted, ref } from "vue";
import Router from "@/core/Router";
import { posterStore } from "@/store/modules/Poster";
import { gsap } from "gsap";
import { resolvePath } from "@/utils/Path";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowPosterPage',
  setup(__props) {

const maskPoster = ref('')

onMounted(() => {
  if(!posterStore.url) {
    Router.push({ name: 'Poster' });
  }

  maskPoster.value = resolvePath(require('@/assets/img/show-mask-poster.png'));

  onEnter();
})

const getPosterUrl = computed(() => posterStore.url);

const generateTrailer = () => {
  Router.push({ name: 'GenerateTrailer' });
}

const root = ref(null);
const onEnter = () => {
  const tl = gsap.timeline()
  const $ = gsap.utils.selector(root.value)

  tl
    .from($('.poster-bg'), {
      opacity: 0,
      scale: 2,
      rotate: -5,
      duration: 1.5,
      ease: 'quart.out',
      stagger: 0.25,
      clearProps: 'all'
    }, 0)
    .from($('.poster-item'), {
      scale: 0,
      yPercent: -45,
      rotate: -25,
      duration: 1.5,
      ease: 'quart.out',
      clearProps: 'scale, yPercent, rotate'
    }, 0.25)
    .from($('.generate-trailer'), {
      scale: 0,
      rotate: -16,
      duration: 1,
      ease: 'quart.inOut',
      clearProps: 'all'
    }, 0.75)
}

return (_ctx: any,_cache: any) => {
  const _component_primary_btn = _resolveComponent("primary-btn")!
  const _component_ui_image = _resolveComponent("ui-image")!

  return (getPosterUrl.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "show-poster h-full",
        ref_key: "root",
        ref: root
      }, [
        _createElementVNode("div", {
          class: "poster-item",
          style: _normalizeStyle({
      'mask-image': `url(${maskPoster.value})`
    })
        }, [
          _hoisted_1,
          _createElementVNode("img", {
            class: "poster-item--overlay",
            src: _unref(resolvePath)(require('@/assets/img/show-mask-overlay.webp')),
            alt: "Overlay"
          }, null, 8, _hoisted_2),
          _createElementVNode("img", {
            src: getPosterUrl.value,
            alt: "Poster"
          }, null, 8, _hoisted_3)
        ], 4),
        _createVNode(_component_primary_btn, {
          class: "generate-trailer",
          onClick: generateTrailer
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('poster.generate_trailer')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ui_image, {
            class: "poster-bg poster-1",
            alt: "teaser",
            image: {
        url: _unref(resolvePath)(require('@/assets/img/bg-poster-1.webp')),
        double: _unref(resolvePath)(require('@/assets/img/bg-poster-1@2x.webp'))
      }
          }, null, 8, ["image"]),
          _createVNode(_component_ui_image, {
            class: "poster-bg poster-2",
            alt: "teaser",
            image: {
        url: _unref(resolvePath)(require('@/assets/img/bg-poster-2.webp')),
        double: _unref(resolvePath)(require('@/assets/img/bg-poster-2@2x.webp'))
      }
          }, null, 8, ["image"]),
          _createVNode(_component_ui_image, {
            class: "poster-bg poster-3",
            alt: "teaser",
            image: {
        url: _unref(resolvePath)(require('@/assets/img/bg-poster-3.webp')),
        double: _unref(resolvePath)(require('@/assets/img/bg-poster-3@2x.webp'))
      }
          }, null, 8, ["image"])
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})